import { _ as _baseIsArguments } from "./auth-service-tools1225.js";
import { i as isObjectLike_1 } from "./auth-service-tools515.js";
var baseIsArguments = _baseIsArguments,
    isObjectLike = isObjectLike_1;
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
var propertyIsEnumerable = objectProto.propertyIsEnumerable;
var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
var isArguments_1 = isArguments;
export { isArguments_1 as i };